
/**
 * C&H Signs — single storefront DOM fix module (phone formatting + contact card).
 * DO NOT add location.replace / cache-bust redirects here.
 * Run: npm run check:safety before pushing theme changes.
 */
(function () {
  'use strict';

  if (window.__CH_SITE_FIXES_LOADED) return;
  window.__CH_SITE_FIXES_LOADED = true;

  var DEFAULT_TEL = '+17656427777';
  var DEFAULT_DISPLAY = '+1(765)-642-7777';
  var DEFAULT_EMAIL = 'sales@candhsigns.com';

  function formatPhone(raw) {
    var digits = String(raw || '').replace(/\D/g, '');
    if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
    if (digits.length !== 10) return null;
    return '+1(' + digits.slice(0, 3) + ')-' + digits.slice(3, 6) + '-' + digits.slice(6);
  }

  function phoneTel(raw) {
    var digits = String(raw || '').replace(/\D/g, '');
    if (digits.length === 11 && digits.charAt(0) === '1') return '+1' + digits.slice(1);
    if (digits.length === 10) return '+1' + digits;
    return DEFAULT_TEL;
  }

  function formatPhoneLinks() {
    document.querySelectorAll('a[href^="tel:"]').forEach(function (link) {
      var tel = phoneTel(link.getAttribute('href').replace(/^tel:/i, ''));
      var display = formatPhone(tel);
      if (!display) return;
      link.setAttribute('href', 'tel:' + tel);
      link.textContent = display;
    });
  }

  function fixContactCard() {
    if (!location.pathname.match(/\/pages\/contact\/?$/)) return;

    if (!document.getElementById('ch-contact-white-text') && document.querySelector('.ch-contact-info-card')) {
      var style = document.createElement('style');
      style.id = 'ch-contact-white-text';
      style.textContent =
        '.ch-contact-info-card h2,.ch-contact-info-card .ch-contact-info-card__title,' +
        '.ch-contact-info-card h3,.ch-contact-info-card p,.ch-contact-info-card a,' +
        '.ch-contact-info-card .ch-contact-hours{color:#fff!important}' +
        '.ch-page-hero--contact h1,.ch-page-hero--contact .ch-page-hero__sub{color:#fff!important}' +
        '.ch-contact-call-link{color:#fff!important;text-decoration:underline!important}';
      document.head.appendChild(style);
    }

    var title = document.querySelector('.ch-contact-info-card__title');
    if (title && !title.querySelector('.ch-contact-call-link')) {
      var tel = 'tel:' + DEFAULT_TEL;
      var callLink = document.createElement('a');
      callLink.className = 'ch-contact-call-link';
      callLink.href = tel;
      callLink.textContent = 'Visit & Call';
      callLink.setAttribute('aria-label', 'Call C&H Signs at ' + DEFAULT_DISPLAY);
      title.textContent = '';
      title.appendChild(callLink);
    }

    var card = document.querySelector('.ch-contact-info-card');
    if (card && !card.querySelector('.ch-contact-info-item')) {
      var telHref = 'tel:' + DEFAULT_TEL;
      card.insertAdjacentHTML(
        'beforeend',
        '<div class="ch-contact-info-item"><h3>Phone</h3><p><a href="' +
          telHref +
          '">' +
          DEFAULT_DISPLAY +
          '</a></p></div>' +
          '<div class="ch-contact-info-item"><h3>Email</h3><p><a href="mailto:' +
          DEFAULT_EMAIL +
          '">' +
          DEFAULT_EMAIL +
          '</a></p></div>'
      );
    }
  }

  function run() {
    formatPhoneLinks();
    fixContactCard();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
